import React, { useEffect, useState } from 'react';
import '../../styles/location.css';
import '../../styles/dashboard.css';
import axios from '../../api/axios.js';
import { notify } from '../toast';
import { useNavigate } from 'react-router-dom';

const Locations = () => {

    const navigate = useNavigate();

    const [villages, setVillages] = useState([]);
    const [mandals, setMandals] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [hospitals, setHospitals] = useState([]);
    const [totalHospitals, setTotalHospitals] = useState(1);
    const [pageLoading, setPageLoading] = useState(false);

    // eslint-disable-next-line
    const [filter, setFilter] = useState({
        village: '',
        mandal: '',
        district: ''
    });

    const bufferToBase64 = (bufferArray) => {
        const chunkSize = 100000;
        let base64String = '';

        for (let i = 0; i < bufferArray.length; i += chunkSize) {
            const chunk = bufferArray.slice(i, i + chunkSize);
            base64String += String.fromCharCode.apply(null, chunk);
        }

        return btoa(base64String);
    }

    useEffect(() => {
        fetchLocations();
        fetchAllHospitals();
        // eslint-disable-next-line
    }, []);

    const fetchLocations = async () => {
        try {

            const response = await axios.get("/public/getLocations");

            const data = response?.data
            setVillages(data?.villages);
            setMandals(data?.mandals);
            setDistricts(data?.districts);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        }
    }

    const fetchAllHospitals = async () => {
        try {

            if (totalHospitals === hospitals.length) return notify('info', 'End of list reached');

            setPageLoading(true);

            const response = await axios.get(`/public/getAllHospitals?page=${Math.ceil(hospitals.length / 12) + 1}`);

            const data = response?.data
            const imageGeneratedHospitals = data?.hospitals?.map((h) => {
                if (h?.photo)
                    return { ...h, photo: `data:image/jpeg;base64,${bufferToBase64(h?.photo?.data)}` }
                return h
            });

            setHospitals(prev => [...prev, ...imageGeneratedHospitals]);
            setTotalHospitals(data?.total);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        } finally {
            setPageLoading(false);
        }
    }

    const handleFilterChange = async (f) => {
        try {

            if (f.village === '' && f.mandal === '' && f.district === '') {
                notify('info', 'Select valid option');
                return
            }

            const response = await axios.get(`/public/getHospitals?village=${f.village}&mandal=${f.mandal}&district=${f.district}`);

            const data = response?.data
            const imageGeneratedHospitals = data?.filteredHospitals?.map((h) => {
                if (h?.photo)
                    return { ...h, photo: `data:image/jpeg;base64,${bufferToBase64(h?.photo?.data)}` }
                return h
            });

            setHospitals(imageGeneratedHospitals);

            setVillages(data?.villages?.length !== 0 ? data.villages : [data?.filteredHospitals.length !== 0 && data?.filteredHospitals[0].village]);
            setMandals(data?.mandals?.length !== 0 ? data.mandals : [data?.filteredHospitals.length !== 0 && data?.filteredHospitals[0].mandal]);
            setDistricts(data?.districts?.length !== 0 ? data.districts : [data?.filteredHospitals.length !== 0 && data?.filteredHospitals[0].district]);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        }
    }

    const reset = () => {
        setFilter({
            village: '',
            mandal: '',
            district: ''
        });
        setHospitals([]);
        setTotalHospitals(1);
        fetchLocations();
        fetchAllHospitals();
    }

    const updateFilter = async (field, value) => {
        const updatedFilter = { ...filter, [field]: value };
        setFilter(updatedFilter);
        await handleFilterChange(updatedFilter);
    };

    return (
        <div>

            <div className='location-filter-container'>
                <div>

                    <section className='location-filter'>
                        <label htmlFor='location-district'>District</label>
                        <select
                            id='location-district'
                            value={filter.district}
                            onChange={(e) => updateFilter('district', e.target.value)}
                        >
                            <option value={''}></option>
                            {districts?.map((district, index) =>
                                <option key={index} value={district}>{district}</option>
                            )}
                        </select>
                    </section>

                    <section className='location-filter'>
                        <label htmlFor='location-mandal'>Mandal</label>
                        <select
                            id='location-mandal'
                            value={filter.mandal}
                            onChange={(e) => updateFilter('mandal', e.target.value)}
                        >
                            <option value={''}></option>
                            {mandals?.map((mandal, index) =>
                                <option key={index} value={mandal}>{mandal}</option>
                            )}
                        </select>
                    </section>

                    <section className='location-filter'>
                        <label htmlFor='location-village'>Village</label>
                        <select
                            id='location-village'
                            value={filter.village}
                            onChange={(e) => updateFilter('village', e.target.value)}
                        >
                            <option value={''}></option>
                            {villages?.map((village, index) =>
                                <option key={index} value={village}>{village}</option>
                            )}
                        </select>
                    </section>

                    <section className='location-filter'><button className="close-btn" onClick={reset}>Reset</button></section>

                </div>
            </div>

            {hospitals?.length !== 0 &&
                <div className='location-hospitals-container'>
                    <section className='location-hospitals'>
                        <div className="location-gallery">
                            {hospitals?.map((hospital) => (
                                <div
                                    key={hospital?._id}
                                    className="location-gallery-item"
                                    style={{
                                        outlineColor: 'var(--primary-color)',
                                        backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.2)),url(${hospital?.photo})`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat",
                                    }}
                                    onClick={() => navigate(`/hospital/${hospital?._id}`)}
                                >
                                    <p>{hospital?.name}</p>
                                </div>
                            ))}
                        </div>
                    </section>
                </div>
            }

            {totalHospitals !== hospitals.length ?
                <div className='container'>
                    <div>
                        <button
                            className='add-btn'
                            disabled={pageLoading}
                            onClick={fetchAllHospitals}>
                            {pageLoading ? <span className='spinner' /> : 'Load more'}
                        </button>
                    </div>
                    <br />
                </div>
                : <></>
            }

        </div>
    )
}

export default Locations
